var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoadmunk({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.85 21.532a4.15 4.15 0 100-8.3 4.15 4.15 0 000 8.3z",
    fill: "#FF7B57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.177 5.324V3.711a.302.302 0 00-.287-.297H3.287A.288.288 0 003 3.711v13.14c0-4.638 2.314-8.958 6.177-11.527z",
    fill: "#26D1C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.85v4.394c0 .16.127.287.287.287H8.88c.159 0 .286-.127.286-.287V5.324A13.844 13.844 0 003 16.85z",
    fill: "#007AE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18 5.325V16.85c0-4.128 3.269-7.514 7.397-7.673a.308.308 0 00.287-.287V3.287a.288.288 0 00-.297-.286c-2.643.053-5.2.86-7.387 2.324z",
    fill: "#3CB7F7"
  })));
}

export default SvgRoadmunk;